import SetPassword from '@routes/_public/-setPassword';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/reset-password/$token')({
  component: ResetPassword,
});

function ResetPassword() {
  const { token } = Route.useParams();
  return <SetPassword context="reset-password" token={token} />;
}
